/* ============================================================
   Stelvio Returns Portal - ETICHETTE DELLE OPZIONI DI CAMBIO.

   PERCHE' UN FILE A PARTE: returns-strings.js contiene modifiche fatte
   a mano da Nicholas. Riscriverlo per cambiare due etichette
   significherebbe cancellarle. Questo file ritocca SOLO le due chiavi
   interessate, lasciando intatto tutto il resto.

   PERCHE' IL TESTO CAMBIA: dai dati emerge che molti clienti chiedono
   il rimborso ma accettano il cambio quando gli viene proposto. Le
   etichette vecchie descrivevano un'operazione ("Cambio taglia/colore")
   senza dire che e' GRATUITO - accanto a "Rimborso" si poteva pensare
   che costasse.

   ORDINE DI CARICAMENTO: va DOPO returns-strings.js e PRIMA di
   returns-portal.js, che legge i dizionari all'avvio.

   REGOLA: niente backslash in questo file (upload via GraphQL).
   ============================================================ */
(function () {
  var S = window.scReturnsSTR;
  if (!S) return;

  var NUOVE = {
    it: { exchange: 'Cambio gratuito', other_product: 'Altro prodotto (gratuito)' },
    en: { exchange: 'Free exchange', other_product: 'Other product (free)' },
    de: { exchange: 'Kostenloser Umtausch', other_product: 'Anderes Produkt (kostenlos)' }
  };

  Object.keys(NUOVE).forEach(function (lang) {
    if (!S[lang]) return;
    Object.keys(NUOVE[lang]).forEach(function (chiave) {
      S[lang][chiave] = NUOVE[lang][chiave];
    });
  });
})();